import { Injectable, inject } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { SelectItem } from '../select.interface';

@Injectable({
  providedIn: 'root',
})
export class TranslateSelectItemsService {
  private translocoService = inject(TranslocoService);

  getTranslatedSelectItems(selectItems: SelectItem[]) {
    return selectItems.map((selectItem) => {
      return { label: this.translocoService.translate(selectItem.label), value: selectItem.value };
    });
  }

  getCountryListTranslated(selectItems: SelectItem[]) {
    return selectItems.map((selectItem) => {
      return { label: this.translocoService.translate('countryList.countryItems.' + selectItem.value), value: selectItem.value };
    });
  }
}
